import { render, staticRenderFns } from "./WvSteakHouseFoodItem.vue?vue&type=template&id=1a5cc45f&scoped=true"
import script from "./WvSteakHouseFoodItem.vue?vue&type=script&lang=ts"
export * from "./WvSteakHouseFoodItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5cc45f",
  null
  
)

export default component.exports